import React, { useEffect, useState  } from "react";
import { useNavigate } from 'react-router-dom';


import { auth, logout, getData, updateDataByUserId } from "../../configs/firebase";
import { onAuthStateChanged } from "firebase/auth";

import { IMAGES } from "../../constants/index"
import { TITLE } from "../../constants/constants"
import { CHECKLSIT, CHECKLSIT_START} from "../../constants/checkList"

import './EpiloguePage.css';

const EPILOGUE = [
    "지난 8일 간의 예수님과 동행하는\n믿음대로 캠페인을 통해",
    "여러분 안에 겨자씨만한 믿음이 생겼다면,\n그것으로 충분합니다.",
    "우리가 주님을 신뢰하며 순종할 때,\n겨자씨만한 그 작은 믿음을 보시고",
    "주님께서\n우리 삶의 큰 산도 옮기실 것입니다.",
    "이 귀중한 깨달음을 마음에 새기고,\n날마다 묵상하며 기도하는 가운데",
    "믿음의 사람으로 성장하시길\n축복합니다.",
    TITLE
]

function EpiloguePage(){
    let navigate = useNavigate();

    const [init,setInit] = useState(false);
    const [user, setUser] = useState(null);
    const [epilogueIndex,setEpilogueIndex] = useState(0)
    const [opacity, setOpacity] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false); 
    const [data,setData] = useState(0)
    const [myFaith,setMyFaith] = useState([])


    // 🔹 로그인 상태 감지
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            if(currentUser) setUser(currentUser);
            else handlelogout()
        });
        return () => unsubscribe();
    }, []);

    // 🔹 첫 시작 시 페이드 인 적용
    useEffect(() => {
        if(user){
            getUserData()
        }
    }, [user]);

    useEffect(() => {
        if(data){
            myFaithData()
        }
    }, [data]);

    useEffect(() => {
        if(myFaith){
            setTimeout(() => {
                setOpacity(1);
            }, 500); // 0.5초 후 페이드 인
        }
    }, [myFaith]);


    const getUserData = async () => {
        const data = await getData(user.uid)
        setData(data[0].checkList)
    }
    const myFaithData = async () => {
        const sortedKeys = Object.keys(data).sort((a, b) => {
            // 🔹 "Day1", "Day2" 등의 숫자 부분만 추출
            const numA = parseInt(a.replace(/[^0-9]/g, ""), 10); // ✅ 숫자만 남김
            const numB = parseInt(b.replace(/[^0-9]/g, ""), 10); // ✅ 숫자만 남김
        
            return numA - numB; // 오름차순 정렬
        });
        
        // 🔥 변환된 데이터 생성 (정렬된 순서 유지)
        const result = sortedKeys.map((key) => ({
            name: key,
            myFaith: (Array.isArray(data[key]) ? data[key] : []).filter((item) => item !== null && item !== "" && item !== undefined).length,
        }));
    
        setMyFaith(result)
    }


    const handleEpilogue = async () => {
        if (epilogueIndex < EPILOGUE.length && !isTransitioning) {
            setIsTransitioning(true);
            setOpacity(0); // 🔥 페이드 아웃 시작
            setTimeout(async () => {
                setOpacity(1); // 🔥 페이드 인 시작
                setTimeout(() => {
                    setIsTransitioning(false); // 🔥 애니메이션 완료 후 다시 클릭 가능
                }, 500); // 페이드 인이 완료된 후 다시 클릭 가능
                setEpilogueIndex(prevIndex => prevIndex + 1);
                if(epilogueIndex===EPILOGUE.length-1){
                    try{
                        const data = { "event": {"prologue":true,"epilogue":true}}
                        await updateDataByUserId(user.uid,data)
                    } catch (e) {
                        console.error("프롤로그 이벤트 업데이트 오류", e)
                    } finally {
                        handleNavigation('/myFaith')
                    }
                }
            }, 1500); // 0.5초 후 변경
        }
    };
    
    const handleNavigation = (address) => {
        navigate(address);
    }
    const handlelogout = async() => {
        const result = await logout()
        navigate('/login');
    }


    function ExternalPage(addrss) {
        // console.log(NOTION,dayIndex,NOTION[dayIndex],addrss)
        return (
            <div style={{ width: "100%", height: "90%" }}>
                <iframe src={addrss} width="100%" height="100%" frameborder="0" allowfullscreen />
            </div>
        );
    }
    // if(!init) return;

    return (
        <div
            className="wrap"
            style={{
                backgroundImage: `url(${IMAGES.BACKGROUMND})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div className="EpilogueWrap" onClick={handleEpilogue} style={{ opacity, transition: "opacity 1s ease-in-out" }}>
                <div className="contentsTitle" ></div>
                <div className="contents">
                {epilogueIndex<EPILOGUE.length&&<pre>{EPILOGUE?.[epilogueIndex] || "로딩 중..."}</pre>}
                {epilogueIndex===0&&
                <p className="showHint">터치해주세요</p>
                }
                </div>
            </div>
        </div>
    );
  }
  export default EpiloguePage;